import { ServerFetch } from '../main-model'

export default class ReturnProductListModel extends ServerFetch {
    getReturnProductListBy = (data) => this.authFetch({
        url: 'return-product-list/getReturnProductListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}